"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductsStreamResponse = exports.getProductsStream = void 0;
const ndjson_1 = require("ndjson");
const routes_1 = require("../../routes");
const getProductsStream = (client) => async (query) => {
    const response = await (0, exports.getProductsStreamResponse)(client)(query);
    return response.data.pipe((0, ndjson_1.parse)());
};
exports.getProductsStream = getProductsStream;
const getProductsStreamResponse = (client) => async (query) => {
    const response = await client.get(routes_1.ENDPOINTS.GET_PRODUCTS.path, {
        headers: {
            accept: 'application/x-ndjson',
        },
        responseType: 'stream',
        params: query,
    });
    return response;
};
exports.getProductsStreamResponse = getProductsStreamResponse;
